module.exports = __webpack_public_path__ + "media/images/video-placeholder-fa3d4cb15ef3fbbfaef10065d95df43d.jpg";